
const Hr = () => {
  return (
    <div className="w-screen border-t border-layout-divider relative left-1/2 -translate-x-1/2" />
  );
};

export default Hr;
